var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ReFormPrinter',{attrs:{"masFormConfig":_vm.masAllFormParams,"objSaveApiMethod":_vm.currentApiFormMethod,"SuccessGo":_vm.SuccessGo,"SuccessBtnText":"Сохранить"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }